export default __webpack_public_path__ + "static/245Park_040925_IPAD_e-ecc3186182380d5e6f232db4aa1b9d1f.pdf";